<div class="rnp" (focusout)="onFocusOut($event)">
  <label class="rnp-label" for="rnp-input">
    {{ "support_requests.nudges_label" | translate }}
    <span class="rnp-hint" *ngIf="hintKey">{{ hintKey | translate }}</span>
  </label>

  <p class="rnp-muted" *ngIf="state === 'loading'" role="status">
    {{ "support_requests.nudges_loading" | translate }}
  </p>
  <p class="rnp-muted" *ngIf="state === 'error'" role="alert">
    {{ "support_requests.nudges_error" | translate }}
    <button type="button" class="rnp-link" (click)="retry.emit()">
      {{ "support_chat.retry" | translate }}
    </button>
  </p>
  <p class="rnp-muted" *ngIf="state === 'ready' && !nudges.length">
    {{ "support_requests.nudges_none" | translate }}
  </p>

  <ng-container *ngIf="state === 'ready' && nudges.length">
    <div
      class="rnp-field"
      [class.rnp-field--open]="open"
      [class.rnp-field--disabled]="disabled"
      (click)="input.focus(); openList()"
    >
      <svg class="rnp-search" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="7"></circle>
        <path d="M20 20l-3.5-3.5"></path>
      </svg>
      <span class="rnp-chip" *ngFor="let id of selected">
        {{ id }}
        <button
          type="button"
          [disabled]="disabled"
          [attr.aria-label]="'support_requests.nudges_remove' | translate: { id: id }"
          (click)="remove(id); $event.stopPropagation()"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18"></path>
          </svg>
        </button>
      </span>
      <input
        #input
        id="rnp-input"
        type="text"
        autocomplete="off"
        role="combobox"
        aria-controls="rnp-list"
        [attr.aria-expanded]="open"
        [disabled]="disabled"
        [value]="query"
        [placeholder]="
          selected.length
            ? ('support_requests.nudges_add_another' | translate)
            : ('support_requests.nudges_placeholder' | translate: { id: example })
        "
        (input)="onQuery(input.value)"
        (focus)="openList()"
        (keydown)="onKeydown($event)"
      />
    </div>

    <div class="rnp-panel" *ngIf="open">
      <div class="rnp-list" id="rnp-list" role="listbox" aria-multiselectable="true">
        <button
          *ngFor="let nudge of results; let i = index; trackBy: trackNudge"
          type="button"
          class="rnp-row"
          role="option"
          tabindex="-1"
          [class.rnp-row--on]="isPicked(nudge.id)"
          [class.rnp-row--active]="i === active"
          [attr.aria-selected]="isPicked(nudge.id)"
          (mousedown)="$event.preventDefault()"
          (click)="toggle(nudge.id)"
        >
          <span class="rnp-check" [class.rnp-check--on]="isPicked(nudge.id)">
            <svg *ngIf="isPicked(nudge.id)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12.5l4.5 4.5L19 7.5"></path>
            </svg>
          </span>
          <span class="rnp-id">{{ nudge.id }}</span>
          <span class="rnp-text">
            <span class="rnp-name">{{ nudge.name || nudge.id }}</span>
            <span class="rnp-page" *ngIf="nudge.page">{{ nudge.page }}</span>
          </span>
          <span class="rnp-tag" [class.rnp-tag--live]="nudge.status === 'live'">
            {{ (nudge.status === "live" ? "support_requests.status_live" : "support_requests.status_paused") | translate }}
          </span>
        </button>
        <div class="rnp-empty" *ngIf="!results.length">
          {{ "support_requests.nudges_no_match" | translate: { query: query.trim() } }}
        </div>
      </div>
      <div class="rnp-footer">
        <span>
          {{
            selected.length
              ? ("support_requests.nudges_selected" | translate: { count: selected.length })
              : ("support_requests.nudges_count" | translate: { count: nudges.length })
          }}
        </span>
        <button type="button" class="rnp-done" (mousedown)="$event.preventDefault()" (click)="closeList()">
          {{ "support_requests.nudges_done" | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <span class="rnp-help">{{ "support_requests.nudges_help" | translate }}</span>
</div>
